import { useState, useEffect } from 'react';

const useLocalStorage = (key: string, initialValue: boolean) => {
    const [storedValue, setStoredValue] = useState(() => {
      if (typeof window !== 'undefined') {
            const item = localStorage.getItem(key);
            return item ? JSON.parse(item) : initialValue;
      }
    });

    useEffect(() => {
        try {
            localStorage.setItem(key, JSON.stringify(storedValue));
        } catch (error) {
            console.error(error);
        }
    }, [key, storedValue]);

    return [storedValue, setStoredValue] as const;
};

export default useLocalStorage;
